module.exports = __webpack_public_path__ + "static/media/back7.814dd21e.jpg";